// ─────────────────────────────────────────────────────────────────
// DECK REGISTRY
// To add a new deck:
//   1. Create src/decks/[slug]/index.js  (copy belitebio-2026 as template)
//   2. Add one entry to DECKS below
//   3. git commit + push → Vercel auto-deploys in ~60 seconds
//   4. Share: interactive.catalystmeded.com/[slug]
// ─────────────────────────────────────────────────────────────────

import BeLiteBio2026 from './belitebio-2026';
import AlkermesCdh from './alkermes_cdh';

export const DECKS = [
  {
    slug: "belitebio-2026",
    title: "BeLite Bio — 2026 Combined Initiative",
    funder: "BeLite Bio",
    ta: "Ophthalmology",
    type: "Combined Initiative",
    year: "2026",
    status: "active",       // active | draft | archived
    created: "2026-03-10",
    component: BeLiteBio2026,
  },
  {
    slug: "alkermes_cdh",
    title: "Alkermes — CDH Learning Center Initiative",
    funder: "Alkermes",
    ta: "Cardiovascular / Diabetes / Hepatology",
    type: "Learning Center Initiative",
    year: "2026",
    status: "active",
    created: "2026-07-01",
    component: AlkermesCdh,
  },
  // ── ADD NEW DECKS ABOVE THIS LINE ──────────────────────────────
];

export function getDeck(slug) {
  return DECKS.find(d => d.slug === slug);
}
